import { Navigate, Outlet } from 'react-router-dom';
import useAuth from '../hooks/useAuth';
import { useEffect } from 'react';

const clearAuthSession = () => {
  sessionStorage.removeItem('user');
  sessionStorage.setItem('isAssistedMode', 'false');
};

const RequireAuth = ({ allowedRoles }) => {
  const { auth } = useAuth();
  const storedQuery = sessionStorage.getItem('query') || '';

  useEffect(() => {
    const popup = window.DigioInstance?.popup;
    if (popup && !popup.closed) popup.close();
    delete window.DigioInstance;
  }, []);

  if (auth?.accessToken) return <Outlet />;

  const isAMLogout = sessionStorage.getItem('isAMLogout') === 'true';
  const isAssistedMode = sessionStorage.getItem('isAssistedMode') === 'true';
  const isSignatory = sessionStorage.getItem('isSignatory') === 'true';
  if (isSignatory) {
    clearAuthSession();
    sessionStorage.setItem('isSignatory', 'false');
    sessionStorage.setItem('isAMLogout', 'true');
    return <Navigate to={`/signatory-login${storedQuery}`} replace />;
  }

  if (isAMLogout || isAssistedMode) {
    clearAuthSession();
    sessionStorage.setItem('isAMLogout', 'true');
    return <Navigate to={`/rmlogin${storedQuery}`} replace />;
  }


  return <Navigate to={`/login${storedQuery}`} replace />;
};

export default RequireAuth;
